<template>
  <ul class="teacherList">
    <li class="teacher-box" v-for="(item, key) in teachersList" :key="key">
      <div class="teacher-head">
        <div class="head-img"><img :src="item.headimg" alt=""></div>
        <div class="name">{{item.name}}</div>
        <div class="fraction">{{item.score}}分</div>
        <div class="flex-box">
          <p>开课：{{item.classopenNum}}</p>
          <p>招生：{{item.teacherId}}</p>
        </div>
      </div>
      <div class="subject">
        <div class="subject-box" @click="lookTeacher(item.teacherId)">{{item.introduce}}</div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'teachersList',
  props: ['teachersList'],
  methods: {
    lookTeacher (id) {
      console.log(id)
      this.$router.push({
        path: '/teacherDetail',
        query: {
          teacherId: id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.teacherList{
  display: flex;
  flex-wrap: wrap;
  .teacher-box{
    width: 267px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    margin: 0px 30px 30px 0px;
    cursor: pointer;
    .teacher-head{
      width: 100%;
      padding: 20px 10px 16px;
      background-color: #f8fafc;
      border-bottom: 1px solid #f0f0f0;
      .head-img{
        width: 110px;
        height: 110px;
        margin: 0 auto;
        border-radius: 50%;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .name{
        width: 100%;
        text-align: center;
        margin-top: 10px;
        color: #333;
        font-size: 16px;
      }
      .fraction{
        width: 110px;
        margin: 10px auto;
        text-align: right;
        color: #bbbbbb;
      }
      .flex-box{
        display: flex;
        justify-content: space-between;
        font-size: 12px;
      }
    }
    .subject{
      padding: 15px;
      .subject-box{
        font-size: 12px;
        color: #999;
        line-height: 20px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
    &:hover{
      box-shadow:1px 2px 4px 1px #ccc;
      margin-top: -10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teachersList.vue